import { Select } from 'antd';
import { ICON_DONE, supportMap, supportOption, SUPPORT_CASE_TYPE } from '../index';
import { useGlobal } from '@/utils/useGlobal';

export default function Step1({ caseData, step, onChangeStep, onChangeCase }: any) {
    const { useLang } = useGlobal();
    const { t } = useLang('supportcasecreate');

    return (
        <div className="step step1">
            <div className="left">
                <div className="icon">{step?.step2 ? <ICON_DONE /> : <p className="number">1</p>}</div>
                <div className="text">
                    <div className="step-title">{t('step1')}</div>
                    {step?.step2 && <button onClick={() => onChangeStep('step1', { caseTypeCode: caseData.caseTypeCode })}>{t('edit')}</button>}
                </div>
            </div>
            <div className="form">
                {step?.step2 && <div className="text-pane">{supportMap[caseData?.caseTypeCode]}</div>}
                {!step?.step2 && (
                    <>
                        <Select
                            size="large"
                            dropdownMatchSelectWidth
                            // style={{ width: getIsPadWidth() ? '100%' : 678 }}
                            value={caseData.caseTypeCode}
                            onChange={(value: string) => onChangeCase({ caseTypeCode: value })}
                            placeholder={t('step1_model_1_placeholder')}
                            options={supportOption}
                        />
                        <button
                            className="btn-next"
                            onClick={() => {
                                if (caseData?.caseTypeCode) {
                                    onChangeStep(caseData?.caseTypeCode == SUPPORT_CASE_TYPE['C&S'] ? 'step3' : 'step2');
                                }
                            }}
                            disabled={!caseData?.caseTypeCode}
                        >
                            {t('btn_next')}
                        </button>
                    </>
                )}
            </div>
        </div>
    );
}
